import { createSlice } from '@reduxjs/toolkit';
// utils

import axios from '../../utils/axios';
// services
import { getSubscription } from '../../services/GMB/subscription/getSubscription';
import { updateSubscription } from '../../services/GMB/subscription/updateSubscription';

const initialState = {
  templatesInitialized: false,
  initialized: false,
  error: null,
  settings: {},
  templates: [],
  customersList: [],
  customersListLoader: false,
  rates: {},
  selfRates: {},
  ratesLoader: false,
  updateRatesLoader: false,
  getTemplatesLoader: false,
  subscriptions: {},
  subscriptionsLoader: false,
  updateSubscriptionsLoader: false,
};

const GMBSlice = createSlice({
  name: 'gmb',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = action.payload;
    },

    // SET SETTINGS SUCCESS
    setSettings(state, action) {
      const details = action.payload;
      const availableSettings = {
        type: details?.type,
        details: details && JSON.parse(details?.details || {}),
      };
      state.settings = availableSettings;
      state.initialized = true;
    },

    // SET TEMPLATES SUCCESS
    setTemplates(state, action) {
      state.templatesInitialized = true;
      state.templates = action?.payload || [];
    },

    // START CUSTOMERS LIST LOADING
    startCustomersListLoader(state) {
      state.customersListLoader = true;
    },
    // STOP CUSTOMERS LIST LOADING
    stopCustomersListLoader(state) {
      state.customersListLoader = false;
    },
    // SET CUSTOMERS LIST SUCCESS
    setCustomersList(state, action) {
      const { childs } = action.payload;
      state.customersListLoader = false;
      state.customersList = childs || [];
    },

    // START RATES LOADING
    startRatesLoader(state) {
      state.ratesLoader = true;
    },
    // STOP RATES LOADING
    stopRatesLoader(state) {
      state.ratesLoader = false;
    },
    // SET RATES SUCCESS
    setRates(state, action) {
      const rates = action.payload;
      state.ratesLoader = false;
      state.rates = rates || {};
    },

    // SET RATES SUCCESS
    setSubscriptions(state, action) {
      const subscriptions = action.payload;

      state.subscriptionsLoader = false;
      state.subscriptions = subscriptions || {};
    },

    // START RATES LOADING
    startUpdateRatesLoader(state) {
      state.updateRatesLoader = true;
    },
    // STOP RATES LOADING
    stopUpdateRatesLoader(state) {
      state.updateRatesLoader = false;
    },

    // START RATES LOADING
    startGetTemplatesLoader(state) {
      state.getTemplatesLoader = true;
    },
    // STOP RATES LOADING
    stopGetTemplatesLoader(state) {
      state.getTemplatesLoader = false;
    },

    // START SUBSCRIPTIONS LOADING
    startSubscriptionsLoader(state) {
      state.subscriptionsLoader = true;
    },
    // STOP SUBSCRIPTIONS LOADING
    stopSubscriptionsLoader(state) {
      state.subscriptionsLoader = false;
    },

    // START UPDATE SUBSCRIPTIONS LOADING
    startUpdateSubscriptionsLoader(state) {
      state.updateSubscriptionsLoader = true;
    },
    // STOP UPDATE SUBSCRIPTIONS LOADING
    stopUpdateSubscriptionsLoader(state) {
      state.updateSubscriptionsLoader = false;
    },

    setSelfRates(state, action) {
      const rates = action.payload;
      state.selfRates = rates || {};
    },
  },
});

// Actions
export const { setSettings, setTemplates } = GMBSlice.actions;

// Reducer
export default GMBSlice.reducer;

export const getSettings = (state) => state.gmb;

export function getSettingsFromApi() {
  return async (dispatch) => {
    try {
      const response = await axios.get('lms_user/api/partner/whatsapp/settings');
      dispatch(GMBSlice.actions.setSettings(response.data.details));
    } catch (error) {
      dispatch(GMBSlice.actions.hasError(error));
    }
  };
}

export function storeSettings(data) {
  return async (dispatch) => {
    try {
      const response = await axios.post('lms_user/api/partner/whatsapp/settings', { params: data });
      dispatch(GMBSlice.actions.setSettings(response.data.details));
    } catch (error) {
      dispatch(GMBSlice.actions.hasError(error));
    }
  };
}

export function getTemplatesFromApi(type) {
  return async (dispatch) => {
    dispatch(GMBSlice.actions.startGetTemplatesLoader());
    try {
      const response = await axios.get(`lms_user/api/partner/whatsapp/${type}/templates`);
      dispatch(GMBSlice.actions.setTemplates(response.data.templates));
      dispatch(GMBSlice.actions.stopGetTemplatesLoader());
    } catch (error) {
      dispatch(GMBSlice.actions.stopGetTemplatesLoader());
      dispatch(GMBSlice.actions.hasError(error));
    }
  };
}


export function getCustomersSubscriptions(type, typeId) {
  return async (dispatch) => {
    dispatch(GMBSlice.actions.startSubscriptionsLoader());
    try {
      const response = await getSubscription(type, typeId);

      // const { subscriptions } = response || {};

      dispatch(GMBSlice.actions.setSubscriptions(response));

      dispatch(GMBSlice.actions.stopSubscriptionsLoader());
    } catch (error) {
      dispatch(GMBSlice.actions.stopSubscriptionsLoader());
      throw new Error(error);
    }
  };
}

export function updateCustomersSubscriptions(newSubscriptionsPricing) {
  return async (dispatch) => {
    dispatch(GMBSlice.actions.startUpdateSubscriptionsLoader());
    try {
      const response = await updateSubscription(newSubscriptionsPricing);
      // const { subscriptions } = response || {};
      dispatch(GMBSlice.actions.setSubscriptions(response));
      dispatch(GMBSlice.actions.stopUpdateSubscriptionsLoader());
    } catch (error) {
      dispatch(GMBSlice.actions.stopUpdateSubscriptionsLoader());
      throw new Error(error);
    }
  };
}

